import React, { useState } from 'react'
import { faHouse, faGear, faUsers, faCalendarDays, faHandHoldingMedical, faBuilding } from '@fortawesome/free-solid-svg-icons'
import { Resumen } from './Resumen';
import MenuLateral from './MenuLateral/MenuLateral';
import { Companys } from './Companys/Companys';

const Agendate = () => {

    const [menuItems, setMenuItems] = useState([
        {
            nombreItem: 'MENU0',
            className: 'menu-item-dashboard-active',
            iconMenu: faHouse,
            menuLabel: 'Resumen'
        },
        {
            nombreItem: 'MENU1',
            className: 'menu-item-dashboard',
            iconMenu: faBuilding,
            menuLabel: 'Compañias'
        },
        {
            nombreItem: 'MENU2',
            className: 'menu-item-dashboard',
            iconMenu: faUsers,
            menuLabel: 'Clientes finales'
        },
        {
            nombreItem: 'MENU3',
            className: 'menu-item-dashboard',
            iconMenu: faHandHoldingMedical,
            menuLabel: 'Servicios'
        },
        {
            nombreItem: 'MENU4',
            className: 'menu-item-dashboard',
            iconMenu: faCalendarDays,
            menuLabel: 'Agendas'
        },
        {
            nombreItem: 'MENU5',
            className: 'menu-item-dashboard',
            iconMenu: faGear,
            menuLabel: 'Configuración'
        },
    ])

    const [stateMenu, setStateMenu] = useState('MENU0');

    const selecionaMenu = (itemSeleccionado) => {
        setStateMenu(itemSeleccionado.nombreItem)
        const nuevoMenuLateral = menuItems.map(itemMenu => {
            if (itemMenu.nombreItem === itemSeleccionado.nombreItem) {
                return { ...itemMenu, className: 'menu-item-dashboard-active' };
            } else {
                return { ...itemMenu, className: 'menu-item-dashboard' };
            }
        });
        setMenuItems(nuevoMenuLateral);
    };

    const componentMenu = () => {
        switch (stateMenu) {
            case 'MENU0':
                return (
                    <Resumen />
                )
            case 'MENU1':
                return (
                    <Companys />
                )
            case 'MENU2':
                return (
                    <>Clientes finales</>
                )
            case 'MENU3':
                return (
                    <>Servicios</>
                )
            case 'MENU4':
                return (
                    <>Agenda -- Gestion Operativa</>
                )
            case 'MENU5':
                return (
                    <>Configuración</>
                )
            default:
                return (
                    <Resumen />
                )
        }
    }

    return (
        <>
            <div className="row m-0">
                <div className="col-12 col-sm-12 col-md-3 col-lg-3 p-0" >
                    <MenuLateral menuItems={menuItems} selecionaMenu={selecionaMenu} />
                </div>
                <div className="col-12 col-sm-12 col-md-9 col-lg-9 p-0" >
                    {
                        componentMenu()
                    }
                </div>
            </div>
        </>
    )
}

export default Agendate
